import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex).attrs({
  px: [2, 24],
  py: [2, 0],
})`
  width: 100%;
  position: relative;
  min-height: 64px;
  align-items: center;

  border-radius: 8px;
  border: solid 1px ${themeGet('colors.softPeach')};
`

export const ImageHolder = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 32px;
  min-width: 32px !important;
  overflow: hidden;
`
